<template>
  <div>
    <h1 class="author-info__name">
      {{ name }}
    </h1>
    <h2 class="subtitle-3">
      {{ jobTitle }}
      <span v-if="company">
        <span class="author-info__delimiter"></span>
        {{ company }}
      </span>
    </h2>
  </div>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'AuthorNameAndPosition',
  props: {
    name: propValidator([PROP_TYPES.STRING]),
    /**
     * This field is missing in the Backend response.
     * ToDo: set required back to true as soon as
     * https://adraba.atlassian.net/browse/FMP-17356 is fixed.
     */
    jobTitle: propValidator([PROP_TYPES.STRING], false),
    /**
     * This field is missing in the Backend response.
     * ToDo: check field name from the Backend as soon as
     * https://adraba.atlassian.net/browse/FMP-17356 is fixed.
     */
    company: propValidator([PROP_TYPES.STRING], false)
  }
}
</script>

<style lang="scss" scoped>
.author-info__name {
  margin-bottom: 10px;
}

.author-info__delimiter {
  display: inline-block;
  margin: 0 20px;
  position: relative;

  @include mobile {
    margin: 0 10px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    width: 2px;
    background: $c--gray;
    height: 29px;

    @include mobile {
      height: 20px;
      bottom: -6px;
    }
  }
}
</style>
